import { useState, useEffect } from 'react'
import { useFetchResources } from '../../../hooks'
import { useSelector } from 'react-redux'


export function useDate(){
  const [dates , setDates ] = useState([])
  const [resourcesSortedByDate, setResourcesSortedByDate] = useState([])
  const { date } = useSelector(state=>state.dateFilter)
  const { resources, isFetchingResources } = useFetchResources()

  useEffect( () => {
    let startDate = moment(date).startOf('week').format("YYYY-MM-DD")
    let times = 6
    let newDates = [startDate]
    for(var i=0; i < times; i++){
      newDates.push(moment(newDates[newDates.length - 1]).add('1', 'days').format('YYYY-MM-DD'))
    }
    setDates(newDates)
    setResourcesSortedByDate(newDates.map( date => {
      let dateMoment = moment(date)
      let dayAfterDateMoment = moment(date).add('1', 'days')

      return ({ 
        date,
        resources: resources.filter(resource => {
          let eventAnchorDateMoment = moment(resource.anchor_date)
          return eventAnchorDateMoment.isSameOrAfter(dateMoment) && eventAnchorDateMoment.isBefore(dayAfterDateMoment)
      })
    })}))
    
  }, [date, resources] )

  return { dates, currentDate: date, resourcesSortedByDate, isFetchingResources }
}